import TenderParticipationDAO  from '@/domains/TenderParticipation/TenderParticipationDAO';

class TenderParticipationService {

	static async updateItem(participation: any): Promise<any> {
		const { data } = await TenderParticipationDAO.updateParticipation(participation);
		return data;
	}
}

export default TenderParticipationService;
